import React from 'react';

const UserBasicDetails = ({ userDetails }) => (
  <div className='bg-white rounded shadow p-4 mb-6'>
    <h2 className='text-lg font-bold mb-4'>Basic Details</h2>
    <table className='w-full'>
      <tbody>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>ID</td>
          <td className='py-1'>{userDetails?.id ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Name</td>
          <td className='py-1'>{userDetails?.firstName + ' ' + userDetails?.lastName  ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Email</td>
          <td className='py-1'>{userDetails?.email ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Phone</td>
          <td className='py-1'>{userDetails?.phone ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Almax Cohort Name</td>
          <td className='py-1'>{userDetails?.UserSubscriptions[0]?.almaxCohortName ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Cohort Name</td>
          <td className='py-1'>{userDetails?.UserSubscriptions[0]?.cohortName ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Plan Type</td>
          <td className='py-1'>{userDetails?.UserSubscriptions[0]?.planType ?? '-'}</td>
        </tr>
        <tr>
          <td className='font-medium pr-4 py-1 text-gray-700'>Course Type</td>
          <td className='py-1'>{userDetails?.UserSubscriptions[0]?.courseType ?? '-'}</td>
        </tr>
        {/* Add more fields as needed */}
      </tbody>
    </table>
  </div>
);

export default UserBasicDetails;